import { Loader } from 'components/Icon';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import apiService from 'utils/apiService';
import useAuth from 'hooks/useAuth';
import { trackIntegrationActivated } from 'utils/integrationAnalytics';

const ABCOauthCallback = () => {
  const [searchParams, _] = useSearchParams();
  const { userInfo } = useAuth();
  const [loading, setLoading] = useState(true);

  const handleCallback = async () => {
    const url = `/api/abc/integration/oauth2callback`;
    const { data } = await apiService.get(`${url}?${searchParams.toString()}`);
    await trackIntegrationActivated('ABC Supply', userInfo, { flush: true });
    setLoading(false);
    window.location = data.redirect_url;
    return;
  };

  useEffect(() => {
    handleCallback();
  }, []);

  if (loading) {
    return (
      <div className="p-8">
        <Loader />
      </div>
    );
  }

  return <div>Redirecting. Please wait...</div>;
};

export default ABCOauthCallback;
